import {
    ServerCIEnvironment,
    ServerEnvironment,
    type ServerBaseUrl
} from '~/servers/types';

/**
 * Server configuration for the US production region (`enterprise.wisesystems.io`)
 */
export const productionServerConfig: ServerBaseUrl = {
    apiServer: 'https://api.wisesys.info',
    auroraApiServer: 'https://aurora-v2.wisesys.info',
    initialVsActualServer:
        'https://p8aowjzsqh.execute-api.us-east-1.amazonaws.com/production',
    equipment: 'https://services-production.us.wisesys.info',
    equipmentSocketServer: 'wss://equipmentsocket-production.us.wisesys.info',
    socketServer: 'wss://prod.socket.wisesys.info',
    auroraServer: 'https://api.aurora-v2.wisesys.info',
    environment: ServerEnvironment.PRODUCTION,
    CIEnv: ServerCIEnvironment.PRODUCTION,
    vehicleProfile:
        'https://ybtfow4mv3.execute-api.us-east-1.amazonaws.com/production',
    routePathGeometryServer:
        'https://ol1vgxgyob.execute-api.us-east-1.amazonaws.com/production',
    configurableWorkflowServer:
        'https://zcqwzh2eue.execute-api.us-east-1.amazonaws.com/Prod',
    driverCostServer:
        'https://lto7uvr6z9.execute-api.us-east-1.amazonaws.com/prod',
    bannerService: 'https://az1mmkwi8l.execute-api.us-east-1.amazonaws.com/prod'
};
